'use client'

import { useEffect } from 'react'

import {
  articleStylesHref,
  compareStylesHref,
  productStylesHref,
  publicStylesHref,
} from '@/lib/styles/generated/asset-urls'

interface DevStylesWindow extends Window {
  __htDevStyleSignature?: string
}

// React retains stylesheet resources across HMR. Reload after a generated
// sheet changes so deleted rules cannot survive in an older resource.
// The locale layout mounts this component only in development.
export const PublicStylesDevReload = () => {
  const signature = `${publicStylesHref}\n${articleStylesHref}\n${productStylesHref}\n${compareStylesHref}`

  useEffect(() => {
    const browser = window as DevStylesWindow
    const previous = browser.__htDevStyleSignature
    browser.__htDevStyleSignature = signature
    if (previous !== undefined && previous !== signature) {
      window.location.reload()
    }
  }, [signature])

  return null
}
